import { render, staticRenderFns } from "./EditFeed.vue?vue&type=template&id=44d66d47&scoped=true&"
import script from "./EditFeed.vue?vue&type=script&lang=js&"
export * from "./EditFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d66d47",
  null
  
)

export default component.exports